import styled from 'styled-components';

import { PartnerLogos } from './PartnerLogos';

type PartnerLogosSectionProps = {
  variant?: 'default' | 'offerIdentity';
};

const PartnerLogosSectionWrapper = styled.div<PartnerLogosSectionProps>(({ variant }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  ...(variant === 'offerIdentity'
    ? {
        background: '#FFFFFF',
        borderRadius: '18px',
        border: '1px solid #DEEBEB',
        padding: '18px 16px',
        boxShadow: '0 6px 22px rgba(1, 64, 65, 0.08)',
      }
    : {}),
}));

export const PartnerLogosSection = ({ variant = 'default' }: PartnerLogosSectionProps) => {
  return (
    <PartnerLogosSectionWrapper variant={variant}>
      <PartnerLogos variant={variant} />
    </PartnerLogosSectionWrapper>
  );
};
